import { useContext } from "react";
import { gabitNameIcon } from "../../../assets/svg";
import { logoutIcon } from "../../../assets/svg";
import "../../../styles/header.scss";
import { useNavigate } from "react-router-dom";
import TrainerContext from "../../../context/trainerContext/TrainerContext";

function Header() {
  const navigate = useNavigate();

  const { getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <div className="container-box bg-white">
      <div className="container-lg d-flex align-items-center justify-content-between">
        <div
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", marginLeft: "16px" }}
        >
          <img src={gabitNameIcon} alt="logo" className="logo-icon" />
        </div>

        <div className="header-btn-group d-flex">
          <button onClick={handleLogout} className="logout-btn btn btn-sm">
            <img src={logoutIcon} className="logout-icon" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
